import { ReactNode, useState } from "react";
import { IconButton, SvgIcon } from "@mui/material";

import "./style.scss";
import { ReactComponent as MenuIcon } from "../../assets/menu.icon.svg";
import { ReactComponent as CloseIcon } from "../../assets/cross.icon.svg";
import { isMobileDevice } from "../../common/utilities/platform/platform.util";
import { ThemeContainer } from "../../common/containers/theme/theme.container";
import Toast from "../toast/toast.comp";

const LeftMenuLayout = ({
    children,
    leftMenu,
    secondLeftMenu
}: {
    children: ReactNode;
    leftMenu: ReactNode;
    secondLeftMenu?: ReactNode;
}) => {
    const { leftMenuCollapsed, leftMenuShown, collapseLeftMenu, setLeftMenuShown } =
        ThemeContainer.useContainer();
    const [isCollapsed, setIsCollapsed] = useState<boolean>(leftMenuCollapsed);

    const collapseExpandLeftMenu = () => {
        setIsCollapsed(prevValue => {
            collapseLeftMenu(!prevValue);
            return !prevValue;
        });
    };

    const showHideLeftMenu = () => {
        setLeftMenuShown(prevValue => !prevValue);
    };

    return (
        <div className={`left-menu-layout${isCollapsed ? " left-menu-layout--collapsed" : ""}`}>
            <a href="#main-content" className="skip-to-content">
                Skip to main content
            </a>
            <nav
                aria-label="Primary"
                className={`collapsible-left-menu${leftMenuShown ? " collapsible-left-menu--shown" : ""}`}
            >
                <div className="collapsible-left-menu-header">
                    <IconButton
                        className="collapsible-left-menu-header__button"
                        aria-label={
                            isCollapsed ? "Expand navigation menu" : "Collapse navigation menu"
                        }
                        aria-expanded={!isCollapsed}
                        onClick={isMobileDevice() ? showHideLeftMenu : collapseExpandLeftMenu}
                    >
                        <SvgIcon component={isCollapsed ? MenuIcon : CloseIcon} inheritViewBox />
                    </IconButton>
                </div>
                <div className="collapsible-left-menu-content">{leftMenu}</div>
            </nav>
            {secondLeftMenu && <div className="second-left-menu">{secondLeftMenu}</div>}
            <main id="main-content" tabIndex={-1} className="children-content">
                {children}
            </main>
            <Toast />
        </div>
    );
};

export default LeftMenuLayout;
